<template>
  <!-- 活动 -->
  <!-- v-if="bannerList.length > 0" -->
  <div ref="container" class="withdraw-dialog" :style="{ 'z-index': zIndex }">
    <div :style="{ 'z-index': zIndex }" class="default-content">

      <div  class="no-more-popups" @click="noMorePopups" v-show="isShowTip"><div class="hide">不再弹出</div></div>
      <div  class="close" id="allDialogClose" @click="closeAllActivity"><img src="./images/btn_close.png"></div>
      <van-swipe class="banner"
                 indicator-color="white"
                 :autoplay="3000"
                 :duration="500"
                 :show-indicators='false'
                 @change="onBannerChange"
      >
        <van-swipe-item
          v-for="(item, index) in allActivity"
          :key="index"
          data-sensors-exposure-property-msg_name="首页弹窗" 
          :data-sensors-exposure-property-model="item.model"
          :data-sensors-exposure-property-caseId="item.type"
          data-sensors-exposure-event-name="PopupDisplay"
        >
          <component :is="item.model" :data="item.data" :mobile="item.mobile" :isLogin="item.isLogin" :type="item.type" :caseid="item.type" ref="dialog" @close="closeAllActivity"/>
        </van-swipe-item>
      </van-swipe>
      <div class="swipe" slot="indicator">
        <div v-show="allActivity.length > 1" class="swipe-indicators" :class="activeBanner===index?'swipe-white':''" v-for="(item,index) in allActivity" :key="index"> </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'
import { setKey } from '@/assets/utils'
import popupManager from '../../../../components/nd-popup-manager'
import InterestFreeDialog1 from '../interest-free-dialog-1/index.vue'
import InterestFreeDialog2 from '../interest-free-dialog-2/index.vue'
import RedPacketDialog1 from '../red-packet-dialog-1/index.vue'
import RedPacketDialog2 from '../red-packet-dialog-2/index.vue'
import NewComerDialog1 from '../new-comer-dialog-1/index.vue'
import NewComerDialog2 from '../new-comer-dialog-2/index.vue'
import NewComerDialog3 from '../new-comer-dialog-3/index.vue'
import DrainageDialog from '../drainage-dialog/index.vue'
import vipDialog from '../vip-dialog/index.vue'
// import couponDialog from '../coupon-dialog/index.vue'
// import xiaomeiVipDialog from '../xiaomei-vip-dialog/index.vue'
import newbieActivityDialog from '../newbie-activity-dialog/index.vue'
import supremeDialog from '../supreme-vip-dialog/index.vue'
import Common from '../common/index.vue'
import Config from '../config-dialog/index.vue'
import { getKey } from '../../../../assets/utils'
import riskControlDialog1 from '../riskControlDialog/dialog1.vue'
import riskControlDialog2 from '../riskControlDialog/dialog2.vue'
import riskControlDialog3 from '../riskControlDialog/dialog3.vue'
import riskControlDialog4 from '../riskControlDialog/dialog4.vue'
import riskControlDialog5 from '../riskControlDialog/dialog5.vue'
import riskControlDialog6 from '../riskControlDialog/dialog6.vue'
import fllowTmdAccountDialog from '../fllow-tmd-account-dialog/index.vue'
import couponV3Diaolog from '../coupon-v3-dialog/index.vue'
import popupRetain from '../dialog-retain/index.vue'
import popupOldcustomerBonus from '../popup-old-customer-bonus/index.vue'

export default {
  data () {
    return {
      activeBanner: 0,
      visible: false,
      allActivityModel: false,
      zIndex: 1000,
      maskInstance: null,
      isClick: false
    }
  },
  mounted () {
    this.maskInstance = this.$mask('', this.$refs['container'])
    this.maskInstance.open()
    this.zIndex = popupManager.generateIndex()
    this.allActivity?.length && this.$refs['dialog'][0].show()
  },

  destroyed () {
    if (this.mask) {
      this.maskInstance.remove()
    }
  },
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    'interestFreeDialog1': InterestFreeDialog1,
    'interestFreeDialog2': InterestFreeDialog2,
    'redPacketDialog1': RedPacketDialog1,
    'redPacketDialog2': RedPacketDialog2,
    'newComerDialog1': NewComerDialog1,
    'newComerDialog2': NewComerDialog2,
    'newComerDialog3': NewComerDialog3,
    'drainageDialog': DrainageDialog,
    'vipDialog': vipDialog,
    // 'couponDialog': couponDialog,
    // 'xiaomeiVipDialog': xiaomeiVipDialog,
    'newbieActivityDialog': newbieActivityDialog,
    'supremeDialog': supremeDialog,
    'common': Common,
    'config': Config,
    riskControlDialog1,
    riskControlDialog2,
    riskControlDialog3,
    riskControlDialog4,
    riskControlDialog5,
    riskControlDialog6,
    fllowTmdAccountDialog,
    couponV3Diaolog,
    popupRetain,
    popupOldcustomerBonus
  },
  props: {
    data: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    allActivity () {
      return JSON.parse(JSON.stringify(this.data))
    },
    isShowTip () {
      if (this.allActivity[this.activeBanner].model === 'newComerDialog3' && !getKey('no-more-popups') && !this.isClick) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    closeAllActivity () {
      this.$report({
        id: 10165
      })
      this.$emit('close')
    },
    noMorePopups () {
      this.$report({
        id: 10164
      })
      setKey('no-more-popups', true)
      this.isClick = true
      this.allActivity.splice(this.activeBanner, 1)
      if (this.allActivity.length === 0) {
        this.closeAllActivity()
      }
    },
    // banner
    onBannerChange (index) {
      this.$refs['dialog'][index].show()     
      this.activeBanner = index
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.withdraw-dialog {
    display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;
    .default-content {
        width: 620px;
        position: relative;
        .banner {
            width: 100%;
        }
    .swipe{
            position: absolute;
            bottom: -40px;
            left: 50%;
            display: flex;
            transform: translateX(-50%);
            &-indicators{
                margin-right:22px;
                width: 18px;
                height: 18px;
                background: #e2dada;
                opacity: 0.2981;
                border-radius: 50%;
            }
            &-white{
                opacity: 1;
            }
        }
    .close {
        position: absolute;
        width: 56px;
        height: 56px;
        right: 22px;
        top: -78px;
        border-radius: 50%;
        overflow: hidden;
            img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border: none;
        }
    }
    .no-more-popups{
        position: absolute;
        right: 97px;
        top: -78px;
        overflow: hidden;
            .hide {
                display: flex;
                justify-content: center;
                align-items: center;
                padding:0 15px;
                height: 58px;
                border-radius: 29px;
                border: 2px solid #FFFFFF;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 40px;
        }
     }
    }
    .header {
        padding: 0 50px;
        margin-top: 17px;
        font-size: 28px;
        text-align: left;
        color: #666666;
        line-height: 40px;
        > span {
            font-size: 42px;
            font-weight: 600;
            color: #333;
            margin-right: 15px;
        }
    }
    .body {
        padding: 0 50px;
        margin-top: 15px;
        > p {
            font-size: 28px;
            text-align: left;
            color: #333333;
            line-height: 40px;
            &:last-child {
                margin-top: 30px;
            }
            .limit {
                font-family: DIN-Medium, DIN;
                font-size: 48px;
                font-weight: 500;
            }
        }
    }
    .footer {
        width: 100%;
        text-align: center;
        margin-top: 56px;
        margin-bottom: 30px;
        .button {
            display: block;
            width: 460px;
            height: 76px;
            line-height: 76px;
            margin: 0 auto;
            margin-bottom: 37px;
        }
        .text-button {
            font-size: 28px;
            text-decoration: underline;
            text-align: left;
            color: #8eb2d8;
        }
    }
}
</style>
